import { FireflyRuntime, RuntimeContext, type Route } from "@squide/firefly";
import { use, useCallback } from "react";
import { matchRoutes, parsePath } from "react-router";

const preloadedRoutes = new WeakSet<Route>();

function ignoreRejection() {}

export function preloadRouteChunks(routes: Route[], href: string): void {
    const { pathname } = parsePath(href);

    if (!pathname?.startsWith("/") || pathname.startsWith("//")) {
        return;
    }

    for (const { route } of matchRoutes(routes, pathname) ?? []) {
        if (typeof route.lazy !== "function" || preloadedRoutes.has(route)) {
            continue;
        }

        preloadedRoutes.add(route);
        route.lazy().catch(ignoreRejection);
    }
}

export function useRoutePreload(): (href: string) => void {
    const runtime = use(RuntimeContext);

    return useCallback(
        (href: string) => {
            if (runtime instanceof FireflyRuntime) {
                preloadRouteChunks(runtime.routes, href);
            }
        },
        [runtime]
    );
}
